module.exports = __webpack_public_path__ + "static/media/id_image_es@2x.6938896e.png";